/**
 * Densidad y gramaje de un material que se compone por fórmula: las mezclas (compuestas por
 * componentes) y el material resultante de la extrusión (compuesto por mezclas).
 *
 * Cada ítem aporta según su Proporcion. Un ítem sin el dato aporta 0 —las proporciones suman
 * 100, que es lo que valida el formulario— y si ninguno lo tiene se devuelve null para no
 * pisar con 0 lo que hubiera cargado. Misma fórmula que aplica el backend al guardar.
 *
 * @param {Array<{CodigoMaterialFormula:number, Proporcion:number}>} formula
 * @param {Array<{Codigo:number, Densidad?:number, Gramaje?:number}>} materiales catálogo de los ítems disponibles
 * @returns {{Densidad: number|null, Gramaje: number|null}}
 */
export function calcularPropiedadesDesdeFormula(formula, materiales) {
  const filas = Array.isArray(formula) ? formula : [];
  const catalogo = Array.isArray(materiales) ? materiales : [];

  if (filas.length === 0 || catalogo.length === 0) {
    return { Densidad: null, Gramaje: null };
  }

  const porCodigo = new Map(catalogo.map((m) => [m.Codigo, m]));

  const ponderar = (propiedad) => {
    let total = 0;
    let algunAporte = false;

    filas.forEach((fila) => {
      const valor = porCodigo.get(fila?.CodigoMaterialFormula)?.[propiedad];
      const proporcion = Number(fila?.Proporcion);
      if (valor == null || !Number.isFinite(proporcion)) return;
      algunAporte = true;
      total += (proporcion / 100) * Number(valor);
    });

    return algunAporte ? Number(total.toFixed(4)) : null;
  };

  return { Densidad: ponderar('Densidad'), Gramaje: ponderar('Gramaje') };
}
